import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const CameraAperture = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M2 16C2 23.72 8.28 30 16 30C23.72 30 30 23.72 30 16C30 8.28 23.72 2 16 2C8.28 2 2 8.28 2 16ZM15.426 4.014L9.661 14L6.55 8.613C8.638 5.948 11.827 4.185 15.426 4.014V4.014ZM18.876 12L21.185 16L18.876 20H13.125L10.816 16L13.125 12H18.876ZM5.334 10.506L10.815 20H4.686C4.242 18.748 4 17.402 4 16C4 14.021 4.482 12.153 5.334 10.506ZM5.611 22H17.721L14.325 27.883C10.603 27.361 7.423 25.125 5.611 22V22ZM16.638 27.983C18.33 25.14 20.625 21.24 20.625 21C20.625 20.991 22.34 18 22.34 18L25.45 23.387C23.374 26.036 20.211 27.795 16.638 27.983V27.983ZM26.666 21.494L21.185 12H27.314C27.758 13.252 28 14.598 28 16C28 17.979 27.518 19.847 26.666 21.494ZM26.389 10H14.279L17.675 4.117C21.397 4.639 24.577 6.875 26.389 10V10Z" />
	</svg>
);

export default CameraAperture;
